import {SystemInfo} from "@/models/SystemInfo";

export class ProviderWorker {
    // anabSystem === companyWorkerAnAbSystem-entry so it hold user-specific-data
    anAbSystem:SystemInfo = new SystemInfo();
    anAbSystemId:string = "";
    companyId:string = ""
    email:string = ""
    userId:string = ""
    id:string = this.userId; // ghost property not given from backend, needed for bryntumgrid
    phoneNumber:string = ""
    dialCode:string = ""
    firstName:string = ""
    lastName:string = ""
    userInfo:string = ""
    isAnonymous:boolean = false
    isAdmin:boolean = false
    isEnabled:boolean = false
}